import * as msgpack from 'msgpack-lite';
import { downloadBlobAsFile } from './save';
import { UserData } from './types';

const signature = new Uint8Array([0xF0, 0x9F, 0x95, 0xAE]);

export async function packWorkspace(
  data: UserData,
  attachments: { readonly [id: string]: Blob },
  fileName: string,
) {
  const mainJSON = JSON.stringify(data);

  const blobParts: any[] = [];
  blobParts.push(signature);
  blobParts.push(msgpack.encode({ version: 1, title: '新しい学習履歴' }));
  blobParts.push(msgpack.encode({ type: 'main' }));
  blobParts.push(makeMessagePackBinChunk(new Blob([mainJSON])));

  for (const id in attachments) {
    blobParts.push(msgpack.encode({ type: 'attachment', filename: id }));
    blobParts.push(makeMessagePackBinChunk(attachments[id]));
  }

  downloadBlobAsFile(new Blob(blobParts), `${fileName}.arkx`);
}

function makeMessagePackBinChunk(data: Blob): Blob {
  const size = data.size;
  let header: Uint8Array;
  if (size < 0xff) {
    header = new Uint8Array([0xc4, size & 0xff]);
  } else if (size < 0xffff) {
    header = new Uint8Array([0xc5, (size >> 8) & 0xff, size & 0xff]);
  } else {
    header = new Uint8Array([0xc6,
      (size >> 24) & 0xff,
      (size >> 16) & 0xff,
      (size >> 8) & 0xff,
      size & 0xff]);
  }

  return new Blob([header, data]);
}
